export default __webpack_public_path__ + "static/media/CookingChannel.8ca47866.svg";